import { Menu, MenuButton, MenuItemProps, useMenuState } from '@vtex/admin-ui'
import { MenuItem } from 'ariakit'
import { ReactNode, useCallback } from 'react'
import { IconArrowRight } from '../../icons'
import styles from './styles.css'

type Props = MenuItemProps & {
  label: ReactNode
  children: ReactNode
  icon?: ReactNode
}

export function NestedMenu(props: Props) {
  const { label, children, icon, ...rest } = props

  const state = useMenuState({
    placement: 'right-start',
    gutter: 12,
    shift: -17,
  })

  const Label = useCallback(
    () => (
      <span>
        {icon}
        {label}
        <IconArrowRight />
      </span>
    ),
    [icon, label]
  )

  return (
    <>
      <MenuButton
        /* @ts-expect-error The `as` property exists on ariakit component and his type was not propagated */
        as={MenuItem}
        state={state}
        label={<Label />}
        className={styles.item}
        variant="neutralTertiary"
        {...rest}
      />
      <Menu state={state} className={styles.nestedMenu}>
        {children}
      </Menu>
    </>
  )
}
